import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductCard from "./ProductCard";
import coke from "../svg/coke.svg"
import mondelez from "../svg/mondelez.svg"
import sanp from "../svg/sanp.svg"
import frito from "../svg/frito.svg"
import dunkin from "../svg/dunkin.svg"
import nestle from "../svg/nestle.svg"

export default function ProductSlider(props) {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
        ]
    };
    return (
        <div className={"bg-transparent " + props.showProductSlider} >
            <div className="mx-auto">
                <h2 className="font-body text-2xl lg:text-4xl text-primary text-center mb-8 lg:mb-16">{props.title}</h2>
                <div className="max-w-6xl mx-auto">
                    <Slider {...settings}>
                        <ProductCard
                            img={coke}
                            alt="Coca Cola Logo"
                        />
                        <ProductCard
                            img={mondelez}
                            alt="Mondelez Logo"
                        />
                        <ProductCard
                            img={sanp}
                            alt="San Pellegrino Logo"
                        />
                        <ProductCard
                            img={nestle}
                            alt="Nestle Logo"
                        />
                        <ProductCard
                            img={frito}
                            alt="Frito Logo"
                        />
                        <ProductCard
                            img={dunkin}
                            alt="Dunkin Logo"
                        />
                    </Slider>
                </div>
            </div>
        </div >

    )
}